/** Keep the customized PDP in sync with Horizon's native variant response. */
(() => {
  'use strict';
  if (window.__irProductSync) return;
  window.__irProductSync = true;
  const pending = new WeakMap();
  const productSection = event => event.target instanceof Element ? event.target.closest('.shopify-section') : null;
  document.addEventListener('variant:selected', event => {
    const section = productSection(event);
    if (!section?.querySelector('.product-details--custom')) return;
    clearTimeout(pending.get(section));
    section.querySelectorAll('.product-action-button').forEach(button => { button.disabled = true; });
    const status = section.querySelector('[data-ir-product-status]');
    if (status) { status.hidden = false; status.textContent = 'Actualizando variante...'; }
    pending.set(section, setTimeout(() => {
      if (!status?.isConnected) return;
      status.textContent = 'No pudimos cargar esta variante. ';
      const retry = document.createElement('a');
      retry.href = location.href;
      retry.textContent = 'Recarg\u00e1 la p\u00e1gina para intentarlo de nuevo.';
      status.append(retry);
    }, 15000));
  });
  document.addEventListener('variant:update', event => {
    const section = productSection(event);
    if (!section?.querySelector('.product-details--custom')) return;
    clearTimeout(pending.get(section));
    const variant = event.detail?.resource;
    const html = event.detail?.data?.html;
    const source = html?.getElementById?.(section.id) || html;
    const available = variant?.available === true;
    const form = section.querySelector('product-form-component form[data-type="add-to-cart-form"]');
    if (!form) return;
    const id = form.querySelector('input[name="id"]');
    if (id) id.value = variant?.id || '';
    const add = form.querySelector('button[name="add"]');
    if (add) {
      add.dataset.variantAvailable = available ? 'true' : 'false';
      add.disabled = !available;
      add.textContent = available ? 'Agregar al Carrito' : (variant ? 'Agotado' : 'No disponible');
      add.dataset.originalText = add.textContent;
    }
    const buy = form.querySelector('[data-buy-now-variant-id]');
    if (buy) { buy.dataset.buyNowVariantId = variant?.id || ''; buy.disabled = !available; }
    for (const selector of ['.product-price-badges-container', '.product-metadata-section']) {
      const current = section.querySelector(selector);
      const fresh = source?.querySelector?.(selector);
      if (current && fresh) current.innerHTML = fresh.innerHTML;
    }
    const quantity = form.querySelector('input[name="quantity"]');
    const freshQuantity = source?.querySelector?.('product-form-component input[name="quantity"]');
    if (quantity && freshQuantity) {
      for (const attribute of ['min', 'max', 'step', 'data-cart-quantity']) {
        if (freshQuantity.hasAttribute(attribute)) quantity.setAttribute(attribute, freshQuantity.getAttribute(attribute));
        else quantity.removeAttribute(attribute);
      }
      const min = Number(quantity.min) || 1;
      const max = Number(quantity.max) || Infinity;
      const step = Number(quantity.step) || 1;
      const desired = Math.max(min, Math.min(max, Number(quantity.value) || min));
      quantity.value = String(Math.max(min, min + Math.floor((desired - min) / step) * step));
    }
    const status = section.querySelector('[data-ir-product-status]');
    if (status) { status.hidden = true; status.textContent = ''; }
    const error = form.querySelector('.ir-product-error');
    error?.classList.add('hidden');
  });
})();
